<template>
  <svg xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 72.763 61.707"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <g id="Group_3686" data-name="Group 3686" transform="translate(-1564.59 -700.677)">
      <g id="Group_3446" data-name="Group 3446" transform="translate(1564.59 700.677)">
        <path :fill="iconColor" id="Path_976" data-name="Path 976" d="M1364.248,462.294a6.064,6.064,0,1,0-6.063-6.063A6.069,6.069,0,0,0,1364.248,462.294Zm0-9.1a3.032,3.032,0,1,1-3.032,3.032A3.036,3.036,0,0,1,1364.248,453.2Z" transform="translate(-1335.446 -425.913)"/>
        <rect :fill="iconColor" id="Rectangle_445" data-name="Rectangle 445" width="3.032" height="4.548" transform="translate(53.056 21.222)"/>
        <path :fill="iconColor" id="Path_977" data-name="Path 977" d="M1195.07,287.9H1181.94a14.95,14.95,0,0,1-1.953-6.064h4.584a12.121,12.121,0,0,0,21.11-.2v.2h16.993a8.336,8.336,0,1,0,11.809-9.7V267.5a6.044,6.044,0,0,0-5.067-5.981,66.383,66.383,0,0,0-7.06-.789v-3.146a1.517,1.517,0,0,1,1.516-1.516v-3.032a4.553,4.553,0,0,0-4.548,4.548v3.04c-.273,0-.547-.009-.82-.009h-2.355l-1.213-12.127h2.873v-3.032H1201.32a7.568,7.568,0,0,0-7.353,5.742l-1.6,6.385h-4.88v3.032h4.122l-.967,3.867a12.133,12.133,0,0,0-7.32,14.323h-15.543v3.032h3.1a18.033,18.033,0,0,0,1.583,6.064h-6.2v3.032h72.763V287.9H1195.07Zm35.623-3.032a5.306,5.306,0,1,1,5.306-5.306A5.312,5.312,0,0,1,1230.693,284.869Zm-1.775-20.361a3.022,3.022,0,0,1,2.532,2.99v3.764c-.25-.023-.5-.036-.758-.036a8.348,8.348,0,0,0-8.3,7.579h-6.1V263.647h2.212A63.57,63.57,0,0,1,1228.918,264.508Zm-15.658-2.3v7.5h-1.043a18.2,18.2,0,0,0-8.052-9.671V248.488h7.723Zm-16.353-10.278a4.543,4.543,0,0,1,4.226-3.441v10.142a18.058,18.058,0,0,0-5.641-1.043Zm-2.17,8.682h.333a15.194,15.194,0,0,1,14.578,11.023l.313,1.1h3.3v6.063h-6.447a12.131,12.131,0,0,0-11.743-15.159c-.372,0-.74.018-1.1.051Zm.333,6.064a9.1,9.1,0,1,1-9.1,9.1A9.105,9.105,0,0,1,1195.07,266.678Zm-21.146,15.159h3.02a18.036,18.036,0,0,0,1.583,6.064h-2.65A14.938,14.938,0,0,1,1173.924,281.837Z" transform="translate(-1166.268 -245.456)"/>
        <path :fill="iconColor" id="Path_978" data-name="Path 978" d="M1211.564,654.946q-.913-.068-1.839-.068h-17.868v3.032h17.868a21.083,21.083,0,0,1,15.006,6.216l3.951,3.951,2.144-2.143-1.96-1.96h26.658v-3.032h-29.758a24.253,24.253,0,0,0-4.28-3.032h37.07v-3.032h-46.993Z" transform="translate(-1188.825 -606.37)"/>
        <path :fill="iconColor" id="Path_979" data-name="Path 979" d="M1217.446,706.056v3.032h14.792a13.916,13.916,0,0,1,9.906,4.1l2.144-2.144a16.932,16.932,0,0,0-12.05-4.992Z" transform="translate(-1211.382 -651.484)"/>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
